import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { wbp, reduceResolution } from 'Theme';

export const useCommonStyles = makeStyles((theme: Theme) =>
    createStyles({
        'root': {
            width: '100%',
            minHeight: '100%',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            overflow: 'hidden',
            background: '#FFF',
            zIndex: 1001,
            display: 'flex',
            flexDirection: 'column'
        },
        'headWrapper': {
            backgroundColor: 'transparent',
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 10,
            paddingTop: 20,
            [theme.breakpoints.up('md')]: {
                paddingLeft: '0',
                paddingRight: '0',
                paddingTop: 28
            }
        },
        'wrapperContainer': {
            padding: '0'
        },
        'content': {
            padding: theme.spacing(2),
            backgroundColor: '#FFF',
            borderRadius: theme.shape.borderRadius,
            [theme.breakpoints.down('sm')]: {
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 0
            }
        },
        'headerContainer': {
            paddingLeft: '0px !important',
            paddingRight: '0px !important',
            marginBottom: 25,
            [theme.breakpoints.down('sm')]: {
                alignItems: 'flex-start',
                marginBottom: 0
            }
        },
        'enrollmentTitle': {
            display: 'flex',
            alignItems: 'center',
            [theme.breakpoints.down('md')]: {
                flexDirection: 'column',
                alignItems: 'flex-start',
                [`& $customBadge`]: {
                    marginTop: 4,
                    marginLeft: 0
                }
            }
        },
        'contentSummaryCard': {
            'display': 'flex',
            'gap': 15,
            'marginTop': 15,
            'marginBottom': 15,
            'overflowX': 'auto',
            'scrollbarWidth': 'none',
            '&::-webkit-scrollbar': {
                display: 'none'
            },
            [theme.breakpoints.down('sm')]: {
                padding: '0 10px',
                marginRight: -15
            }
        },
        'cardSummaryContainer': {
            [theme.breakpoints.down('sm')]: {
                width: '170px',
                minWidth: '170px',
                maxWidth: '170px'
            }
        },
        'cardSummary': {
            borderRadius: 14,
            border: '1px solid #D4D4D4'
        },
        'SelectionBar': {
            [theme.breakpoints.up('md')]: {
                marginTop: 25,
                backgroundColor: '#FFF',
                marginBottom: 10
            },
            [theme.breakpoints.down('sm')]: {
                paddingTop: 10,
                paddingBottom: 10
            }
        },
        'noMobile': {
            [theme.breakpoints.down('md')]: {
                display: 'none'
            }
        },
        'badge': {
            marginLeft: 10,
            [theme.breakpoints.down('sm')]: {
                marginTop: 5,
                marginLeft: 0
            }
        },
        'membershipOptionsButton': {
            'all': 'unset',
            'fontSize': 21,
            '& svg': {
                display: 'block'
            }
        },
        'toolbarButton': {
            fontSize: 18
        },
        'searchBarContainer': {
            [theme.breakpoints.down('sm')]: {
                paddingBottom: 0
            }
        },
        'headerActionPopup': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: '25px'
        },
        'headerActionPopupTitle': {
            fontWeight: 600,
            color: '#000000',
            fontSize: '16px',
            textAlign: 'left',
            display: 'block',
            width: '100%'
        },
        'titleContainer': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '16px',
            backgroundColor: '#FFF',
            flex: '0 0 auto'
        },
        'title': {
            fontSize: 20,
            fontWeight: 600,
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)'
        },
        'logo': {
            display: 'flex',
            alignItems: 'center'
        },
        'desktop': {
            display: 'block',
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        },
        'mobile': {
            display: 'block',
            [theme.breakpoints.up('md')]: {
                display: 'none'
            }
        },
        'closeIcon': {
            fontSize: 20,
            fontWeight: 600
        },
        'membershipDetailsBody': {
            backgroundColor: '#FAFAFA',
            flex: '1 1 auto',
            overflow: 'auto',
            minHeight: 0,
            paddingBottom: 40
        },
        'membershipDetailsContainer': {
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
            flex: 'auto',
            width: '100%',
            height: '100%',
            maxWidth: '100%',
            margin: '0 auto',
            padding: '0 20px',
            [theme.breakpoints.up('lg')]: {
                maxWidth: 1235
            },
            [theme.breakpoints.up('xl')]: {
                maxWidth: 1400
            }
        },
        'petCard': {
            'paddingBottom': 13,
            'marginBottom': 13,
            'borderBottom': '1px solid #eee',
            '&:last-child': {
                borderBottom: 'none',
                paddingBottom: 0,
                marginBottom: 0
            }
        },
        'petCardImage': {
            width: 56,
            height: 56,
            marginRight: 10
        },
        'petSizeContainer': {
            flexWrap: 'wrap'
        },
        'petItemLabel': {
            width: 'auto'
        },
        'cardStyle': {
            borderRadius: 16,
            border: '1px solid #D4D4D4',
            background: '#FFF'
        },
        'cardContent': {
            'padding': '25px 18px',
            '&:last-child': {
                paddingBottom: '20px'
            }
        },
        'cardWide': {
            'padding': '25px 22px',
            '&:last-child': {
                paddingBottom: '20px'
            }
        },
        'cardTitle': {
            fontSize: 18,
            fontWeight: 600,
            marginBottom: 10,
            lineHeight: '120%'
        },
        'cardSubtitle': {
            fontSize: 14,
            color: '#000',
            marginBottom: 20,
            lineHeight: '120%'
        },
        'cardTitlePets': {
            marginBottom: 5,
            marginTop: 5
        },
        'titleLabel': {
            fontSize: 16,
            color: '#000',
            fontWeight: 600,
            marginBottom: 3
        },
        'labelValue': {
            textTransform: 'capitalize'
        },
        'subscriptionTypeItemIcon': {
            marginRight: 5
        },
        'membershipItemsGrid': {
            borderBottom: '2px solid #000',
            paddingBottom: 10,
            marginBottom: 10,
            width: 'calc(100% + 44px)',
            marginLeft: '-22px',
            marginTop: 20
        },
        'membershipItemsTitleLeft': {
            paddingLeft: 22
        },
        'membershipItemsTitleRight': {
            paddingRight: 22
        },
        'membershipItemsTitle': {
            color: '#000',
            fontSize: 16,
            fontWeight: 600
        },
        'membershipItemsRow': {
            'borderBottom': '1px solid #eee',
            'padding': '12px 0',
            '&:last-child': {
                borderBottom: 'none',
                paddingBottom: 0
            }
        },
        'membershipItemsItemName': {
            fontSize: 16,
            fontWeight: 500
        },
        'membershipItemsItemLabel': {
            fontSize: 14,
            fontWeight: 400,
            color: '#7A7A7A'
        },
        'loadingContainer': {
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        'loadingContainerError': {
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center'
        },
        'confirmQuestion': {
            fontSize: '16px',
            color: '#000',
            maxWidth: '445px',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginBottom: 10
        },
        'select': {
            textAlign: 'left',
            paddingLeft: '20px',
            paddingRight: '20px',
            maxWidth: '95%',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginBottom: 5,
            [theme.breakpoints.down('md')]: {
                maxWidth: '100%'
            }
        },
        '@global': {
            '[class*="makeStyles-select"] [class*="makeStyles-labelContainer"]': {
                'paddingLeft': 0,
                'paddingRight': 0,
                'marginLeft': 0,
                'marginRight': 0,
                'marginBottom': 5,
                '& .MuiTypography-body1': {
                    fontWeight: 600,
                    fontSize: '16px'
                }
            }
        },
        'detailMainContainer': {
            zIndex: 999
        },
        'detailContainer': {
            [theme.breakpoints.down('sm')]: {
                flexWrap: 'unset',
                flexGrow: 'unset'
            }
        },
        'imageEmpty': {
            width: '100%',
            maxWidth: '375px',
            display: 'inline-block',
            marginBottom: 20
        },
        'boxAlerts': {
            marginTop: 0,
            marginBottom: 0
        },
        'alertMessage': {
            marginBottom: 10
        },
        'buttonContainer': {
            marginTop: 10,
            display: 'flex',
            gap: 15,
            alignItems: 'center'
        },
        'optionAction': {
            'fontWeight': 600,
            'fontSize': 14,
            'borderBottom': '1.5px solid currentColor',
            'display': 'inline-flex',
            'alignItems': 'center',
            'cursor': 'pointer',
            'paddingBottom': '1px',
            '& svg': {
                marginRight: 5
            }
        },
        'spinnerRetry': {
            width: 24,
            height: 24,
            marginRight: 0
        },
        'spinnerCircularProgressRetry': {
            animation: 'none',
            width: '100% !important',
            height: '100% !important',
            display: 'inline-flex',
            color: '#000'
        },
        'warningIcon': {
            color: '#E36E74'
        },
        'containerCardsDrawer': {
            'display': 'flex',
            'height': '100%',
            'flexDirection': 'column',
            'padding': '0px 30px 30px 35px',
            '&.MuiDrawer-root.MuiDrawer-modal': {
                //zIndex: '99 !important'
            },
            '& .MuiDrawer-paperAnchorRight': {
                width: '100%',
                [theme.breakpoints.up('md')]: {
                    width: '590px !important',
                    zIndex: 999
                }
            }
        },
        'backdrop': {
            backgroundColor: 'transparent'
        },
        'headerDrawer': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '30px 0px 25px 0px'
        },
        'titleDrawer': {
            fontSize: 22,
            fontWeight: 600,
            [theme.breakpoints.down('sm')]: {
                fontSize: 20
            }
        },
        'iconDrawer': {
            fontSize: 24,
            fontWeight: 500,
            [theme.breakpoints.down('sm')]: {
                fontSize: 20
            }
        },
        'bodyDrawer': {},
        'cardGroup': {
            backgroundColor: '#fff'
        },
        'activityLogContainer': {
            marginTop: 20
        }
    })
);

export default useCommonStyles;
